import Footer from '../components/footer'
import navBar from '../components/navBar'

const Pods = ()=>{
    return(
        <>
        <navBar />
        
        <div className="container" style={{height:"10rem", marginTop:"20rem"}}>
            <h2>Pods Section Coming Soon</h2>
        </div>
        <Footer />
        </>
    )
}

export default Pods;